import { useEffect,useRef,useState } from "react";
import useLicense from "../hooks/useLicense"
import NotificationBarItem from "./NotificationBarItem";
import LicenseBar from "../components/notification-bar/LicenseBar";
import { useCurrent } from "../hooks";

const NotificationBar = () => {
    const {currentCompany} = useCurrent();
    const barRef = useRef(null);
    
    //console.log("currentCompany",currentCompany);
    const [isShowLicense,setIsShowLicense] = useState(false);
    const [isShowUpdateVat,setIsShowUpdateVat] = useState(false);
    const isVatNnumberUpdated = JSON.parse(localStorage.getItem('isVatNnumberUpdated') || false);

    // License Handler
    const {data:dataLicense,loading:loadingLicense,licenseDays,TRAIL_PERIOD_DAYS,typeLicense} = useLicense(false);
    
    // License Loader Handler
    useEffect(() => {
        if(dataLicense && !loadingLicense ){
            setIsShowLicense(true);
        }
    },[dataLicense]);

    useEffect(() => {
        if(currentCompany){
            const hasVat = currentCompany.hasVat;
            const vatNumber = currentCompany.vatNumber;
            if(hasVat && !vatNumber && !isVatNnumberUpdated){
                setIsShowUpdateVat(true)
            }
        }
    },[currentCompany]);

    useEffect(() => {
        const barElement = barRef.current;
        const update = () => {
            document.documentElement.style.setProperty('--notification-height', `${barElement?.offsetHeight || 0}px`);
        };
        update();
        if (!barElement) return;
        const observer = new ResizeObserver(update);
        observer.observe(barElement);
        return () => observer.disconnect();
    }, []);

    return (
        <div ref={barRef}>
            {
                isShowLicense && licenseDays <= TRAIL_PERIOD_DAYS && 
                <NotificationBarItem setShow={setIsShowLicense}>
                    <LicenseBar licenseDays={licenseDays} typeLicense={typeLicense}  />
                </NotificationBarItem>     
            }
        </div>
    )
}

export default NotificationBar
